<div class="anonimni-kontakt-container">
  <!-- Header Section -->
  <div class="header-section">
    <div class="header-row">
      <div class="header-group">
        <h2 class="page-title">Anonimni Kontakti</h2>
        <p class="page-subtitle">Lista svih anonimnih kontakata</p>
      </div>

      <!-- Refresh Button -->
      <div class="header-group">
        <dx-button text="Osvježi podatke" icon="refresh" type="default" stylingMode="contained" (onClick)="loadData()"
          class="refresh-btn">
        </dx-button>
      </div>
    </div>
  </div>

  <!-- Data Grid Section -->
  <div class="grid-section">
    <dx-data-grid #anonimniKontaktGrid id="anonimniKontaktGrid" keyExpr="id" [dataSource]="gridData" [showBorders]="true"
      [allowColumnResizing]="true" [showColumnLines]="true" [showRowLines]="true" [hoverStateEnabled]="true"
      [filterRow]="{ visible: true }" [searchPanel]="{ visible: true }" [paging]="{ pageSize: 50 }" [pager]="{
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      }" [selection]="{ mode: 'single' }" [rowAlternationEnabled]="true">

      <!-- Columns Definition -->
      <dxi-column type="buttons" width="80" caption="Opcije" [visible]="isUserModerator">
        <dxi-button name="delete" icon="trash" hint="Izbriši" [visible]="true" [onClick]="onDeleteClick"></dxi-button>
      </dxi-column>

      <dxi-column dataField="datum" caption="Datum" dataType="date" format="dd.MM.yyyy"></dxi-column>
      <dxi-column dataField="naziv" caption="Naziv"></dxi-column>
      <dxi-column dataField="kontakt" caption="Kontakt"></dxi-column>
      <dxi-column dataField="tekst" caption="Tekst"></dxi-column>

      <!-- Master Detail -->
      <dxo-master-detail [enabled]="true" template="detailTemplate">
      </dxo-master-detail>

      <div *dxTemplate="let data of 'detailTemplate'" class="master-detail">
        <div class="detail-section">
          <h4>Detalji anonimnog kontakta</h4>
          <p><strong>Datum:</strong> {{ data.data.datum | date:'dd.MM.yyyy' }}</p>
          <p><strong>Naziv:</strong> {{ data.data.naziv || 'N/A' }}</p>
          <p><strong>Kontakt:</strong> {{ data.data.kontakt || 'N/A' }}</p>
          <p><strong>Tekst:</strong> {{ data.data.tekst || 'N/A' }}</p>
        </div>
      </div>
    </dx-data-grid>
  </div>

  <!-- Loading Overlay -->
  <dx-load-panel [position]="loadPanelPosition" [visible]="loading" [showIndicator]="true" [showPane]="true"
    [shading]="true" shadingColor="rgba(0, 0, 0, 0.4)">
  </dx-load-panel>
</div>